
import { Search, MessageSquare, Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface InboxHeaderProps {
  filterActive: boolean;
  setFilterActive: (active: boolean) => void;
  unreadCount: number;
}

const InboxHeader = ({ 
  filterActive, 
  setFilterActive,
  unreadCount 
}: InboxHeaderProps) => {
  return (
    <div className="border-b border-gray-200 dark:border-gray-700/50 p-4 bg-white dark:bg-[#1a1d2d] transition-colors">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold flex items-center text-gray-900 dark:text-gray-100">
          <MessageSquare className="h-5 w-5 mr-2 text-custom-primary dark:text-custom-secondaryLight" />
          Commentaires
          {unreadCount > 0 && (
            <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-custom-primary dark:bg-custom-secondaryLight text-white dark:text-custom-dark">
              {unreadCount}
            </span>
          )}
        </h2>
        
        <div className="flex space-x-2">
          <Button
            variant="outline"
            size="sm"
            className={`px-3 ${
              filterActive
                ? 'bg-custom-primaryLight text-custom-primary border-custom-primary dark:bg-custom-primary/20 dark:text-custom-secondaryLight dark:border-custom-secondaryLight'
                : 'text-gray-600 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-800/80'
            }`}
            onClick={() => setFilterActive(!filterActive)}
          >
            <Filter className="h-4 w-4 mr-1" />
            Non lus
          </Button>
        </div>
      </div>

      <div className="mt-3 relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-4 w-4 text-gray-400" />
        </div>
        <input
          type="text"
          placeholder="Rechercher un commentaire..."
          className="pl-10 form-input block w-full rounded-md border border-gray-300 dark:border-gray-700 dark:bg-gray-800/50 dark:text-gray-200 dark:placeholder-gray-500 focus:border-custom-primary dark:focus:border-custom-secondaryLight focus:ring focus:ring-custom-primary/20 dark:focus:ring-custom-secondaryLight/20 transition-colors"
        />
      </div>
    </div>
  );
};

export default InboxHeader;
